module.exports = "<span\n  ng-init=\"$ctrl.tooltip()\"\n  class=\"icon icon-interrogation-color\"\n  data-toggle=\"tooltip\"\n  data-placement=\"{{$ctrl.placement}}\"\n  title=\"{{ $ctrl.title | translate }}\">\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/tooltipDesktop/tooltipDesktop.html
// module id = 1019
// module chunks = 0